<template>
    <article>
        <p>
            I'm very excited to welcome <a href="https://www.linkedin.com/in/peterzaitsev/" target="_blank">Peter Zaitsev</a> to Coroot!
            I will let him to speak more about his reasons for joining.
        </p>

        <div class="pa-5 my-6">
            <v-img eager class="ma-auto" src="/static/img/blog/peter-zaitsev.jpeg" />
        </div>

        <p>
            From my early days as a Software Engineer,
            I was interested in complicated systems’ internal operations, what is happening inside, how they work, and why they fail.
            This is what brought me to the Open Source Database Community.
            It was to help customers operate complicated database-powered systems that
            <a href="https://www.percona.com/" target="_blank">Percona</a> was created.
        </p>
        <p>
            At Percona we spent a lot of time improving the core observability of MySQL
            (<a href="https://www.percona.com/mysql/software/percona-server-for-mysql" target="_blank">Percona Server for MySQL</a>),
            helped to advance state of art of Open Source Database Observability with
            <a href="https://www.percona.com/software/database-tools/percona-monitoring-and-management" target="_blank">Percona Monitoring and Management (PMM)</a>
            and helped to advance PostgreSQL query performance observability by creating <a href="https://github.com/percona/pg_stat_monitor" target="_blank">pg_stat_monitor</a>.
        </p>
        <p>
            What I have learned through the years though is – while we’re able to capture a lot of data on system operations
            and we can visualize it in hundreds of beautiful graphs, it is overwhelming for the majority of engineers.
            They are looking for specific relevant information about the investigation and actionable on solving the issue or
            even better-automated problem remediation when possible.
        </p>
        <p>
            This is why I was very excited when I discovered Nikolay Sivko was building Coroot.
            Nikolay had a lot of experience in operating complicated systems and had previously created successful Observability platforms,
            yet he had come to the same conclusion – in the age of extremely complicated environments (Microservices, Serverless, Cloud Native)
            we rarely need more data or visualizations but rather better solutions for making sense of the data and finding the root cause of the problems.
        </p>
        <p>
            Nikolay believes there is a better way to approach Observability in this new generation of system architectures and I fully share his vision.
        </p>
        <p>
            This is why I am joining Coroot as a Co-Founder to help Nikolay with my experience in the industry
            to take Open Source Observability of Modern Applications and Infrastructure to the Next Level.
        </p>
        <p>
            I have also personally invested in the project and I will help raise additional capital to accelerate our mission.
        </p>
        <p>
            Interested in joining us on this journey as a user, team member, investor, or partner?
            Feel free to <a href="https://peterzaitsev.com/get-in-touch/" target="_blank">drop me a note</a>.
        </p>
        <p>
            P.S. To learn more about Coroot you can
            check out <a href="https://coroot.com/blog/minimizing-observability-tax" target="_blank">How it Works</a>,
            check out <a href="https://community-demo.coroot.com/" target="_blank">Live Demo</a>.
            When you can try <a href="https://coroot.com/cloud" target="_blank">Coroot Cloud</a>
            or roll your installation with <a href="https://github.com/coroot/coroot" target="_blank">Coroot Open Source</a>.
        </p>
        <p>
            P.P.S. I will be at <a href="https://fosdem.org/2024/" target="_blank">FOSDEM</a> (Brussels)
            and <a href="https://stateofopencon.com/" target="_blank">State of Open Con</a> (London) in early February.
            Let me know if you’d like to connect in person.
        </p>
    </article>
</template>

<script>
export default {
}
</script>

<style scoped>
</style>
